import moment from "moment";

export const getToday = () => {
	const d = new Date();
	d.setHours(0, 0, 0, 0);
	return d;
};


export const formatDate = (date, row = null, format = null) => {
	if (!date) {
		return null;
	}
	const d = moment(date).format(format || "DD.MM.YYYY");
	return d;
	// return date ? moment(date).format(format ? format : moment.localeData().longDateFormat('L')) : '';
};

export const parseDate = (date) => {
	return date ? moment(date) : null;
};

export const timeToHours = (time) => {
	if (!time) {
		return 0
	}
	const hundreds = 1 * time.replace(':', '');
	return Math.floor(hundreds / 100) + ((hundreds % 100) / 60); // 1245 => 12.75
};

export const hoursToTime = (hours) => {
	const h = Math.floor(hours) % 24;
	const m = (hours % 1) * 60;
	return ("00" + h).substring(("00" + h).length - 2) + ":" + ("00" + m).substring(("00" + m).length - 2);
};

export const durationHours = (timeFrom, timeTo) => {
	return (timeTo === '00:00' ? 24 : timeToHours(timeTo)) - timeToHours(timeFrom);
};

export const durationDays = (dateFrom, dateTo) => {
	return moment(dateFrom).diff(moment(dateTo), 'days')
};
export const addDays = (dateFrom, days) => {
	return moment(dateFrom).add(days, 'days');
};
export const addInterval = (dateFrom, num, what) => {
	return moment(dateFrom).add(num, what);
};

export const intervalsFromDates = (dates) => {
	return dates.length <= 1
		? formatDate(dates[0])
		: (formatDate(dates[0]) + " - " + formatDate(dates[dates.length - 1]));
};

export const getHoliday = (date) => {
	const y = date.year();
	if (!easters[y]) {
		const sunday = easterDate(y);
		easters[y] = {
			'friday': moment(sunday).add(-2, "day"),
			'monday': moment(sunday).add(1, "day"),
		}
	}

	if (date.isSame(easters[y].monday, 'day')) {
		return "Velikonoční pondělí";
	} else if (date.isSame(easters[y].friday, 'day')) {
		return "Velký pátek";
	} else {
		return (holidays[date.format('DD/MM')]);
	}
};

const holidays = {
	'01/01': "Den obnovy samostatného českého státu",
	'01/05': "Svátek práce",
	'08/05': "Den vítězství",
	'05/07': "Den slovanských věrozvěstů Cyrila a Metoděje",
	'06/07': "Den upálení mistra Jana Husa",
	'28/09': "Den české státnosti",
	'28/10': "Den vzniku samostatného československého státu",
	'17/11': "Den boje za svobodu a demokracii",
	'24/12': "Štědrý den",
	'25/12': "1. svátek vánoční",
	'26/12': "2. svátek vánoční"
};

const easters = {};

const easterDate = (year) => {
	let a = (year / 100 | 0) * 1483 - (year / 400 | 0) * 2225 + 2613;
	let b = ((year % 19 * 3510 + (a / 25 | 0) * 319) / 330 | 0) % 29;
	// return 56 - b - ((year * 5 / 4 | 0) + a - b) % 7;

	let c = 148 - b - ((year * 5 / 4 | 0) + a - b) % 7;

	return moment({year: year, month: (c / 31 | 0) - 1, day: c % 31 + 1});
};
